import { useMemo, useRef } from 'react'

type ResourceRow = { resourceId: string }

export const useStableResourceDataSource = (resources: ResourceRow[]): ResourceRow[] => {
  const dataRef = useRef<ResourceRow[]>([])
  const fingerprintRef = useRef('')

  return useMemo(() => {
    const fingerprint = resources.map((resource) => resource.resourceId).join(';')
    if (fingerprint === fingerprintRef.current) {
      return dataRef.current
    }

    fingerprintRef.current = fingerprint
    const next = resources.map(({ resourceId }) => ({ resourceId }))
    dataRef.current = next
    return next
  }, [resources])
}
